export const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://licapi.urbanonorte.com.br"
    : process.env.REACT_APP_API_URL || "http://localhost:3333";

export const INVESTMENT_CAPITAL_OPTIONS = [
  "R$50.000,00",
  "R$50.000,00 a R$100.000,00",
  "R$100.000,00 a R$200.000,00",
  "Acima de R$200.000,00",
];
export const INVESTMENT_INTEREST = ["Sim", "Não", "A depender da Proposta"];

export const IS_APP_DRIVER = ["Sim", "Não"];
